const PILLS_FETCH = 'bfb/pills/PILLS_FETCH';
const PILLS_FETCH_SUCCEEDED = 'bfb/pills/PILLS_FETCH_SUCCEEDED';
const PILLS_FETCH_FAILED = 'bfb/pills/PILLS_FETCH_FAILED';

export default {
  PILLS_FETCH,
  PILLS_FETCH_SUCCEEDED,
  PILLS_FETCH_FAILED,
};
